import React, { ReactElement } from "react";
import { ProjectStateType } from "../../interfaces/ProjectStateType";
import { Tag } from "../../components";
import { useTranslation } from "react-i18next";

const ProjectStateTag = ({
  state,
}: {
  state: ProjectStateType;
}): ReactElement => {
  const { t } = useTranslation();

  switch (state) {
    case "OPEN":
      return <Tag variant="danger">{t("PROJECT_STATES.OPEN")}</Tag>;
    case "ON_HOLD":
      return <Tag variant="default">{t("PROJECT_STATES.ON_HOLD")}</Tag>;
    case "CLOSED":
      return <Tag variant="success">{t("PROJECT_STATES.CLOSED")}</Tag>;
  }

  return <></>;
};

export default ProjectStateTag;
